import { ComponentInstall } from "../../utils";
import PaginationTable from "./src";

export default ComponentInstall(PaginationTable);
